import React, { useCallback, useEffect, useMemo, useState } from 'react'

import InputText from '../InputText'
import { dateFns, today } from '../../constants'
import { maskDate } from '../../helpers'

export function DateInput({ value, onChange, icon, adornment, invalid, ...props }) {
  const [tempValue, setTempValue] = useState(() => {
    if (value) {
      return dateFns.format(value, 'keyboardDate')
    }

    return ''
  })

  useEffect(() => {
    if (value && dateFns.isValid(value)) {
      setTempValue(dateFns.format(value, 'keyboardDate'))
    }
  }, [value])

  const tempValueDate = useMemo(() => (tempValue ? dateFns.parse(tempValue, 'dd/MM/yyyy') : null), [tempValue])

  const valid = useMemo(() => {
    if (tempValueDate) {
      return dateFns.isValid(tempValueDate) && !dateFns.isAfterDay(tempValueDate, today)
    }

    return true
  }, [tempValueDate])

  const handleOnChange = useCallback(() => {
    if (tempValueDate && valid) {
      onChange(tempValueDate)
    }
  }, [valid, onChange, tempValueDate])

  const handleTempValueChange = useCallback((e) => {
    const maskedValue = maskDate(e.target.value)
    setTempValue(maskedValue)
  }, [])

  const handleInputFocus = useCallback((e) => {
    e.target.setSelectionRange(0, e.target.value.length)
  }, [])

  return (
    <InputText
      {...props}
      error={invalid || !valid}
      helperText={(invalid || !valid) && 'Data inválida'}
      value={tempValue}
      InputProps={{
        startAdornment: icon === 'left' ? adornment : null,
        endAdornment: icon === 'right' ? adornment : null,
      }}
      onChange={handleTempValueChange}
      onFocus={handleInputFocus}
      onBlur={handleOnChange}
    />
  )
}
